import Vue from "vue";
import Router from "vue-router";
import {concat} from "lodash";
import App from "../App";
import DocumentOutRouter from "./document-out";
import DocumentInRouter from "./document-in";
import DashboardRouter from "./dashboard";
import BookRouter from "./book";
import loginRouter from "./login";
import shortLink from "./shortLink";
import authenService from "../services/authenService";
import JobRouter from "./job";
import SettingRouter from "./setting";
import ReportRouter from "./report";
import AdminstarionRouter from "./adminstration";
import Contact from "./contact";
import ActionHistory from "./actionHistory";
import Document from "./document";
import Discussion from "./discussion";
import Notifi from "./notifi";
import News from "./news";
import utils from "../services/utils";

Vue.use(Router);

const VueRouter = new Router({
  routes: concat(
    [
      {
        path: "/app/:userDeptRoleId",
        name: "app",
        component: App,
        beforeEnter: (to, from, next) => {
          authenService.checkIsAuthenticated().then(valid => {
            valid ? next() : next({name: "login"});
          });
        },

        children: concat(
          JobRouter,
          DocumentOutRouter,
          DocumentInRouter,
          BookRouter,
          SettingRouter,
          AdminstarionRouter,
          DashboardRouter,
          Contact,
          Document,
          Discussion,
          Notifi,
          News,
          ReportRouter,
          ActionHistory,
          [
            {
              path: "/app/:userDeptRoleId/*",
              redirect: "/app/:userDeptRoleId/dashboard"
            }
          ]
        )
      }
    ],

    loginRouter,

    [
      {
        path: "/intermediateViewDetail/:type",
        name: "detailRouting",
        component: () =>
          import("../views/intermediateViewDetail/intermediateViewDetail.vue"),
        beforeEnter: (to, from, next) => {
          if (utils.checkDeviceIsMobile()) {
            next();
          } else {
            authenService.checkIsAuthenticated().then(valid => {
              valid
                ? next()
                : authenService
                  .storeStateBeforeLogin(to)
                  .then(() => next({name: "login"}));
            });
          }
        }
      }
    ],

    shortLink,

    [
      {
        path: "*",
        redirect: {
          name: "login"
        }
      }
    ]
  )
});

export default VueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js